(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('LegalActualInfoController', LegalActualInfoController);

    LegalActualInfoController.$inject = ['LegalActualInfoService', '$translate', '$scope', 'SelectorData', 'SelectorDataQuery', '$rootScope'];

    function LegalActualInfoController(LegalActualInfoService, $translate, $scope, SelectorData, SelectorDataQuery, $rootScope) {
        var vm = this;
        vm.error = null;
        vm.success = null;
        vm.isSaving = false
        vm.legalInfo = {}

        vm.save = save;
        vm.closeModal = closeModal;
        vm.okModal = okModal;

        loadData()

        function loadData(){
            const res = LegalActualInfoService.fetchInfo().query()
            vm.legalInfo = res
        }


        function save() {
            vm.isSaving = true;
            LegalActualInfoService.fetchInfo().update(vm.legalInfo, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
           vm.legalInfo = result;
           vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


        function closeModal() {
            if ($rootScope.modalInstance) {
                $rootScope.modalInstance.dismiss('cancel');
            }

        }

        function okModal() {
            save();
            $rootScope.modalInstance.dismiss('cancel');
        }

    }
})();
